(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mb-shipping-gate"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById('mb-shipping-gate');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const dialog = root.querySelector('[data-mb-dialog]');
    const zipStep = root.querySelector('[data-mb-step="zip"]');
    const boxStep = root.querySelector('[data-mb-step="boxes"]');
    const zipForm = root.querySelector('[data-mb-zip-form]');
    const zipInput = root.querySelector('#mb-gate-zip');
    const zipError = root.querySelector('[data-mb-zip-error]');
    const generalError = root.querySelector('[data-mb-general-error]');
    const boxMessage = root.querySelector('[data-mb-box-message]');
    const statusButton = root.querySelector('[data-mb-change-zip]');
    const capacityStatus = root.querySelector('[data-mb-capacity-status]');
    const capacityLabel = root.querySelector('[data-mb-capacity-label]');
    const capacityValue = root.querySelector('[data-mb-capacity-value]');
    const capacityTrack = root.querySelector('[data-mb-capacity-track]');
    const strings = JSON.parse(root.querySelector('[data-mb-translations]').textContent);
    const localZips = new Set(root.dataset.localZips.split(','));
    const boxes = {
      small: { id: Number(root.dataset.smallVariant), capacity: 22, name: 'Small' },
      large: { id: Number(root.dataset.largeVariant), capacity: 32, name: 'Large' },
      jumbo: { id: Number(root.dataset.jumboVariant), capacity: 40, name: 'Jumbo' }
    };
    const boxIds = new Set(Object.values(boxes).map(box => box.id)); const capacityOf = id => Object.values(boxes).find(box => box.id === id)?.capacity || 0;
    let pendingForm = null;
    let forceQuantity = false;
    let capacityAnimation = 0;

    const showStep = step => {
      zipStep.hidden = step !== 'zip';
      boxStep.hidden = step !== 'boxes';
      generalError.hidden = true;
      if (!dialog.open) dialog.showModal();
      if (step === 'zip') setTimeout(() => zipInput.focus(), 20);
    };

    const getCart = async () => {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('cart');
      return response.json();
    };

    const updateAttributes = async attributes => {
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes })
      });
      if (!response.ok) throw new Error('attributes');
      return response.json();
    };

    const applyDeliveryMethod = method => {
      document.documentElement.dataset.mbDeliveryMethod = method === 'local' ? 'local' : method === 'shipping' ? 'shipping' : 'unknown';
    };

    const gramsToLb = grams => Math.round((Number(grams) / 453.59237) * 100) / 100;
    const labeledWeight = label => {
      const text = String(label || '');
      const values = [];
      for (const match of text.matchAll(/(\d+(?:\.\d+)?)\s*(?:lbs?|pounds?)\b/gi)) values.push(Number(match[1]));
      for (const match of text.matchAll(/(\d+(?:[.,]\d+)?)\s*(?:kg|kgs|kilograms?)\b/gi)) values.push(Number(match[1].replace(',', '.')) * 2.20462262);
      for (const match of text.matchAll(/(\d+(?:\.\d+)?)\s*(?:oz|ounces?)\b/gi)) values.push(Number(match[1]) / 16);
      return values.length ? Math.max(...values) : 0;
    };
    const itemWeight = item => {
      const label = [item.variant_title, item.product_title, item.title, ...(item.options_with_values || []).map(option => option.value)].filter(Boolean).join(' ');
      const configuredWeight = gramsToLb(item.grams); if (configuredWeight > 0) return configuredWeight; const packageWeight = labeledWeight(label);
      if (packageWeight > 0) return packageWeight;
      
      return 1;
    };
    const productWeight = cart => cart.items.reduce((total, item) => boxIds.has(item.variant_id) ? total : total + (itemWeight(item) * item.quantity), 0);
    const boxCapacity = cart => cart.items.reduce((total, item) => {
      const box = Object.values(boxes).find(candidate => candidate.id === item.variant_id);
      return total + (box ? box.capacity * item.quantity : 0);
    }, 0);

    const protectShippingBoxes = () => {
      if (localStorage.getItem('mb_delivery_method') !== 'shipping') return;
      document.querySelectorAll('a[href*="/cart/change"]').forEach(link => {
        const id = new URL(link.href, location.origin).searchParams.get('id') || '';
        if (![...boxIds].some(boxId => id.startsWith(String(boxId)))) return;
        link.hidden = true;
        link.setAttribute('aria-hidden', 'true');
        const row = link.closest('tr, .cart-item, [data-cart-item]');
        row?.querySelectorAll('button').forEach(button => {
          if (button.textContent.trim() === '-') {
            button.disabled = true;
            button.setAttribute('aria-disabled', 'true');
          }
        });
      });
    };

    const updateCapacityStatus = async () => {
      try {
        const cart = await getCart();
        const capacity = boxCapacity(cart);
        if (!capacity) {
          capacityStatus.hidden = true;
          return;
        }
        const remaining = Math.round((capacity - productWeight(cart)) * 100) / 100;
        const target = Math.max(0, remaining);
        const percentage = Math.max(0, Math.min(100, (target / capacity) * 100));
        const previous = Number(capacityStatus.dataset.remaining ?? target);
        const startedAt = performance.now();
        cancelAnimationFrame(capacityAnimation);
        capacityLabel.textContent = remaining >= 0 ? strings.capacityRemaining : strings.capacityNeeded;
        capacityStatus.style.setProperty('--mb-capacity-progress', `${percentage}%`);
        capacityStatus.classList.toggle('is-low', percentage > 15 && percentage <= 35);
        capacityStatus.classList.toggle('is-critical', percentage <= 15);
        capacityStatus.classList.remove('is-updating');
        if (Math.abs(previous - remaining) > .01) {
          void capacityStatus.offsetWidth;
          capacityStatus.classList.add('is-updating');
        }
        const animateNumber = now => {
          const progress = Math.min(1, (now - startedAt) / 650);
          const eased = 1 - Math.pow(1 - progress, 3);
          const displayed = previous + (remaining - previous) * eased;
          const rounded = Math.round(Math.abs(displayed) * 100) / 100;
          const unit = rounded === 1 ? 'lb' : 'lbs';
          capacityValue.textContent = `${rounded} ${unit}`;
          if (progress < 1) capacityAnimation = requestAnimationFrame(animateNumber);
        };
        capacityAnimation = requestAnimationFrame(animateNumber);
        capacityStatus.dataset.remaining = String(remaining);
        capacityTrack.setAttribute('aria-valuenow', String(Math.round(percentage)));
        capacityTrack.setAttribute('aria-valuetext', (remaining >= 0 ? strings.remainingA11y : strings.neededA11y).replace('[weight]', remaining >= 0 ? target : Math.abs(remaining)));
        capacityStatus.hidden = false;
      } catch (_) {
        capacityStatus.hidden = true;
      }
    };

    const syncBoxQuantities = async () => {
      const cart = await getCart();
      const requiredWeight = productWeight(cart);
      let capacity = boxCapacity(cart);
      if (!capacity) return updateCapacityStatus();
      const boxLines = cart.items
        .filter(item => boxIds.has(item.variant_id))
        .sort((a, b) => capacityOf(b.variant_id) - capacityOf(a.variant_id));
      for (const item of boxLines) {
        const boxSize = capacityOf(item.variant_id);
        let nextQuantity = item.quantity;
        while (nextQuantity > 0 && capacity - boxSize + 0.01 >= requiredWeight) {
          nextQuantity -= 1;
          capacity -= boxSize;
        }
        if (nextQuantity !== item.quantity) {
          const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: nextQuantity })
          });
          if (!response.ok) throw new Error('box sync');
        }
      }
      await updateCapacityStatus();
    };

    const requestedWeight = async form => {
      const idField = form.querySelector('[name="id"]');
      if (!idField) return 0;
      const quantityField = Array.from(document.querySelectorAll('[name="quantity"]')).find(field => field.form === form) || form.querySelector('[name="quantity"]');
      const quantity = Number(quantityField?.value || 1);
      const context = form.closest('.card-wrapper, .product-card, .product-block, .product, .product__info-container, li, article') || form.parentElement;
      try {
        const response = await fetch(`${window.Shopify.routes.root}variants/${idField.value}.js`, { headers: { Accept: 'application/json' } });
        if (response.ok) {
          const variant = await response.json(); const configuredWeight = gramsToLb(variant.weight ?? variant.grams); if (configuredWeight > 0) return configuredWeight * quantity;
          const packageWeight = labeledWeight([variant.name, variant.title, variant.public_title, context?.textContent].filter(Boolean).join(' '));
          if (packageWeight > 0) return packageWeight * quantity;
          
          if (configuredWeight > 0) return configuredWeight * quantity;
        }
      } catch (_) {}
      return (labeledWeight(context?.textContent) || 1) * quantity;
    };

    const resumeAdd = async () => {
      if (!pendingForm) return;
      const form = pendingForm;
      pendingForm = null;
      if (dialog.open) dialog.close();
      if (!window.MBMinimumOrders || !window.MBMinimumOrders.validateForm(form)) return;
      const idField = form.querySelector('[name="id"]');
      const quantityField = Array.from(document.querySelectorAll('[name="quantity"]')).find(field => field.form === form) || form.querySelector('[name="quantity"]');
      if (!idField) throw new Error('Missing product variant.');
      const cartDrawer = document.querySelector('cart-drawer');
      const sections = cartDrawer?.getSectionsToRender?.().map(section => section.id) || [];
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(idField.value), quantity: Number(quantityField?.value || 1) }],
          sections,
          sections_url: window.location.pathname
        })
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.description || result.message || strings.networkError);
      if (cartDrawer?.renderContents && result.sections) {
        cartDrawer.renderContents(result);
      } else {
        window.location.assign(`${window.Shopify.routes.root}cart`);
      }
      updateCapacityStatus();
    };

    const ensureCapacity = async () => {
      const cart = await getCart();
      const next = pendingForm ? await requestedWeight(pendingForm) : 0;
      if (boxCapacity(cart) + 0.01 >= productWeight(cart) + next) return true;
      boxMessage.textContent = strings.boxFull;
      showStep('boxes');
      return false;
    };

    const saveZip = async zip => {
      const local = localZips.has(zip);
      await updateAttributes({ 'MB ZIP Code': zip, 'MB Delivery Method': local ? 'local' : 'shipping' });
      localStorage.setItem('mb_delivery_zip', zip);
      localStorage.setItem('mb_delivery_method', local ? 'local' : 'shipping');
      applyDeliveryMethod(local ? 'local' : 'shipping');
      updateStatus(zip);
      if (local) {
        if (pendingForm) await resumeAdd();
        else if (dialog.open) dialog.close();
        return;
      }
      const cart = await getCart();
      if (boxCapacity(cart) > 0 && boxCapacity(cart) + .01 >= productWeight(cart) + (pendingForm ? await requestedWeight(pendingForm) : 0)) {
        if (pendingForm) await resumeAdd();
        else if (dialog.open) dialog.close();
        await updateCapacityStatus();
        return;
      }
      boxMessage.textContent = strings.boxBody;
      showStep('boxes');
    };

    const addBox = async type => {
      const box = boxes[type];
      const cartBefore = await getCart();
      const pendingWeight = pendingForm ? await requestedWeight(pendingForm) : 0;
      const requiredWeight = productWeight(cartBefore) + pendingWeight;
      const availableCapacity = boxCapacity(cartBefore);
      const quantityToAdd = Math.max(1, Math.ceil((requiredWeight - availableCapacity) / box.capacity));
      const cartDrawer = document.querySelector('cart-drawer');
      const sections = cartDrawer?.getSectionsToRender?.().map(section => section.id) || [];
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: box.id, quantity: quantityToAdd, properties: { '_mb_shipping_box': box.name, '_mb_capacity_lb': String(box.capacity) } }],
          sections,
          sections_url: window.location.pathname
        })
      });
      if (!response.ok) throw new Error('box');
      const addedResult = await response.json();
      const addedLine = addedResult.items?.[0] || addedResult;
      const previousQuantity = cartBefore.items.reduce((total, item) => item.variant_id === box.id ? total + item.quantity : total, 0);
      const correctedQuantity = previousQuantity + quantityToAdd;
      const correction = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: addedLine.key || box.id, quantity: correctedQuantity })
      });
      if (!correction.ok) throw new Error('box quantity');
      await updateAttributes({ 'MB Box Selection': `${box.name} × ${quantityToAdd} (${box.capacity} lb each)` });
      await updateCapacityStatus();
      if (!pendingForm) {
        if (cartDrawer?.renderContents && addedResult.sections) cartDrawer.renderContents(addedResult);
        return dialog.close();
      }
      const capacityAfter = availableCapacity + (box.capacity * quantityToAdd);
      if (capacityAfter + .01 >= requiredWeight) return resumeAdd();
      boxMessage.textContent = strings.boxFull;
      showStep('boxes');
    };

    const updateStatus = zip => {
      if (!zip) { statusButton.hidden = true; return; }
      statusButton.textContent = strings.status.replace('[zip]', zip);
      statusButton.hidden = false;
    };

    zipForm.addEventListener('submit', async event => {
      event.preventDefault();
      const zip = zipInput.value.replace(/\D/g, '').slice(0, 5);
      zipError.hidden = zip.length === 5;
      if (zip.length !== 5) return;
      try { await saveZip(zip); } catch (_) { generalError.textContent = strings.networkError; generalError.hidden = false; }
    });

    root.querySelectorAll('[data-mb-box]').forEach(button => button.addEventListener('click', async () => {
      button.disabled = true;
      try { await addBox(button.dataset.mbBox); } catch (error) { generalError.textContent = error.message || strings.networkError; generalError.hidden = false; }
      finally { button.disabled = false; }
    }));
    root.querySelector('[data-mb-close]').addEventListener('click', () => dialog.close());
    statusButton.addEventListener('click', () => { zipInput.value = localStorage.getItem('mb_delivery_zip') || ''; showStep('zip'); });

    document.addEventListener('click', async event => {
      const submitter = event.target.closest('button[type="submit"],input[type="submit"]');
      const form = submitter?.form;
      if (!(form instanceof HTMLFormElement) || !/\/cart\/add(?:\.js)?$/.test(new URL(form.action, location.href).pathname)) return;
      if (form.dataset.mbApproved === 'true') return;
      const zip = localStorage.getItem('mb_delivery_zip');
      const method = localStorage.getItem('mb_delivery_method');
      if (zip && method === 'local') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      pendingForm = form;
      if (!zip || !method) return showStep('zip');
      try {
        if (await ensureCapacity()) await resumeAdd();
      } catch (error) { generalError.textContent = error.message || strings.networkError; generalError.hidden = false; showStep('boxes'); }
    }, true);

    document.addEventListener('submit', async event => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !/\/cart\/add(?:\.js)?$/.test(new URL(form.action, location.href).pathname)) return;
      if (form.dataset.mbApproved === 'true') {
        delete form.dataset.mbApproved;
        return;
      }
      const zip = localStorage.getItem('mb_delivery_zip');
      const method = localStorage.getItem('mb_delivery_method');
      if (zip && method === 'local') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      pendingForm = form;
      if (!zip || !method) return showStep('zip');
      try {
        if (method === 'local' || await ensureCapacity()) await resumeAdd();
      } catch (_) { generalError.textContent = strings.networkError; generalError.hidden = false; showStep(method === 'shipping' ? 'boxes' : 'zip'); }
    }, true);

    document.addEventListener('click', async event => {
      const plus = event.target.closest('button[name="plus"]');
      if (!plus || forceQuantity || localStorage.getItem('mb_delivery_method') !== 'shipping') return;
      const input = plus.closest('quantity-input')?.querySelector('input[name="updates[]"]');
      const line = Number(input?.dataset.index || 0);
      if (!line) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      try {
        const cart = await getCart();
        const item = cart.items[line - 1];
        if (item && !boxIds.has(item.variant_id) && productWeight(cart) + itemWeight(item) > boxCapacity(cart) + .01) {
          pendingForm = null;
          boxMessage.textContent = strings.boxFull;
          return showStep('boxes');
        }
        forceQuantity = true;
        plus.click();
        setTimeout(() => { forceQuantity = false; }, 0);
      } catch (_) {
        generalError.textContent = strings.networkError;
        generalError.hidden = false;
        showStep('boxes');
      }
    }, true);

    document.addEventListener('click', event => {
      const minus = event.target.closest('button[name="minus"]');
      if (!minus || localStorage.getItem('mb_delivery_method') !== 'shipping') return;
      const row = minus.closest('tr, .cart-item, [data-cart-item]');
      if (!row?.querySelector('a[href*="/products/small-insulated-shipping-box"],a[href*="/products/large-insulated-shipping-box"],a[href*="/products/jumbo-insulated-shipping-box"]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      boxMessage.textContent = strings.checkoutError;
      showStep('boxes');
    }, true);

    document.addEventListener('click', async event => {
      const checkout = event.target.closest('[name="checkout"],a[href$="/checkout"],a[href*="/checkout?"]');
      if (!checkout || checkout.dataset.mbCheckoutReady === 'true') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      try {
        const zip = localStorage.getItem('mb_delivery_zip');
        const method = localStorage.getItem('mb_delivery_method');
        if (!zip || !method) { pendingForm = null; return showStep('zip'); }
        const cart = await getCart();
        if (method === 'shipping' && boxCapacity(cart) + .01 < productWeight(cart)) { boxMessage.textContent = strings.checkoutError; return showStep('boxes'); }
        checkout.dataset.mbCheckoutReady = 'true';
        window.location.assign(`${window.Shopify.routes.root}checkout`);
      } catch (_) { generalError.textContent = strings.networkError; generalError.hidden = false; showStep('zip'); }
    }, true);

    const savedZip = localStorage.getItem('mb_delivery_zip');
    applyDeliveryMethod(localStorage.getItem('mb_delivery_method'));
    updateStatus(savedZip);
    if (!/^\d{5}$/.test(savedZip || '') && !window.Shopify.designMode) showStep('zip');
    protectShippingBoxes();
    updateCapacityStatus();
    document.addEventListener('click', event => {
      const control = event.target.closest('button[name="plus"],button[name="minus"],a[href*="/cart/change"]');
      if (!control) return;
      const row = control.closest('tr, .cart-item, [data-cart-item]');
      if (row?.querySelector('a[href*="/products/small-insulated-shipping-box"],a[href*="/products/large-insulated-shipping-box"],a[href*="/products/jumbo-insulated-shipping-box"]')) return;
      setTimeout(() => { syncBoxQuantities().catch(() => updateCapacityStatus()); }, 900);
    }, true);
    new MutationObserver(protectShippingBoxes).observe(document.body, { childList: true, subtree: true });
    if (/\/products\/(small|large|jumbo)-insulated-shipping-box/.test(location.pathname)) location.replace(`${window.Shopify.routes.root}collections/all`);
      const syncMobileCartReminder = async () => {
            try {
                    const response = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
                            if (!response.ok) return;
                                    const cart = await response.json();
                                            const count = Number(cart.item_count || 0);
                                                    const reminder = document.querySelector('.mb-cart-reminder');
                                                            if (!reminder) return;
                                                                    reminder.setAttribute('aria-label', `Open cart, ${count} ${count === 1 ? 'item' : 'items'}`);
                                                                            const countElement = reminder.querySelector('span[aria-hidden="true"]');
                                                                                    if (countElement) countElement.textContent = count;
                                                                                          } catch (_) {}
                                                                                              };
                                                                                              
                                                                                                  document.addEventListener('click', event => {
                                                                                                        if (event.target.closest('.mb-cart-reminder')) {
                                                                                                                document.body.classList.add('mb-cart-drawer-open'); document.querySelector('shopify-forms-embed')?.style.setProperty('visibility', 'hidden', 'important');
                                                                                                                        setTimeout(syncMobileCartReminder, 300);
                                                                                                                                return;
                                                                                                                                      }
                                                                                                                                            if (event.target.closest('cart-drawer button[aria-label="Close"], cart-drawer [data-close]')) document.body.classList.remove('mb-cart-drawer-open'); document.querySelector('shopify-forms-embed')?.style.removeProperty('visibility');
                                                                                                                                                  if (event.target.closest('button[type="submit"], input[type="submit"], button[name="plus"], button[name="minus"], a[href*="/cart/change"]')) {
                                                                                                                                                          setTimeout(syncMobileCartReminder, 500);
                                                                                                                                                                  setTimeout(syncMobileCartReminder, 1500);
                                                                                                                                                                        }
                                                                                                                                                                            }, true);
                                                                                                                                                                                syncMobileCartReminder();
                                                                                                                                                                                })();
  } catch(e) { console.error(e); }
})();

})();
